const all = new Map()

const Bus = {
  all,
  on(ev, cb, options = {}) {
    const { unique } = options

    const cbs = all.get(ev)
    if (cbs && !unique) cbs.push(cb)
    else all.set(ev, [cb])
  },
  off(ev, cb) {
    const cbs = all.get(ev)
    if (cbs) cbs.splice(cbs.indexOf(cb) >>> 0, 1)
    else all.set(ev, [])
  },
  emit(ev, ...args) {
    const cbs = all.get(ev)
    if (cbs) {
      if (cbs.length === 1) return cbs[0].apply(this, args)
      cbs.forEach(cb => cb.apply(this, args))
    }
  },
}

Object.defineProperties(Bus, {
  $on: {
    get() {
      return Bus.on
    },
  },
  $off: {
    get() {
      return Bus.off
    },
  },
  $emit: {
    get() {
      return Bus.emit
    },
  },
})

window.Bus = Bus

export default Bus
